import {
  Action,
  ActionType,
  UpdateUserDepartmentResponse,
} from "models/userListBusiness/updateUserDepartment";

import createReducer from "../../createReducer";

export interface UpdateUserDepartmentReducerType {
  loading: boolean;
  error?: string;
  updateUserDepartmentResponse?: UpdateUserDepartmentResponse;
}

const defaultState: UpdateUserDepartmentReducerType = {
  loading: false,
  error: undefined,
  updateUserDepartmentResponse: undefined,
};

export const updateUserDepartmentReducer =
  createReducer<UpdateUserDepartmentReducerType>(defaultState, {
    [ActionType.UPDATE_USER_DEPARTMENT](
      state: UpdateUserDepartmentReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPDATE_USER_DEPARTMENT_ERROR](
      state: UpdateUserDepartmentReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.UPDATE_USER_DEPARTMENT_SUCCESS](
      state: UpdateUserDepartmentReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        updateUserDepartmentResponse: action.payload,
      };
    },

    [ActionType.UPDATE_USER_DEPARTMENT_RESET](
      state: UpdateUserDepartmentReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        updateUserDepartmentResponse: undefined,
      };
    },
  });
